<template>
  <div>
    <div class="container">
      <div>
        <el-switch active-text="隐藏销量" v-model="form.hidesalesvolume" :active-value="2" :inactive-value="1" />
      </div>
      <div style="margin-top:33px;">
        <el-switch active-text="开启祝福卡片" v-model="form.enablegiftcard" :active-value="2" :inactive-value="1" />
      </div>
      <div class="footer">
        <el-button @click="onSave" type="primary">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../service/grpc.js';
import { rpc } from '../../service/index.js';
import { getToken } from '../../service/helper.js';
import uploadFile from '../../components/uploadFile/index.vue';
import data from '../../assets/sc';
import ssx from '../../assets/ssx';

export default {
  components: {
    'upload-file': uploadFile
  },
  data() {
    return {
      form: {}
    };
  },
  async created() {
    this.token = getToken();
    const res = await rpc('StoreAuthService.GetStore', M('Token', { token: this.token }));
    this.form = res;
  },
  methods: {
    async onSave() {
      const params = { ...this.form };
      var o = await rpc(
        'StoreStoreService.UpdateInfo',
        M('StoreWithTokenRequest', {
          token: M('Token', { token: this.token }),
          store: M('Store', {
            ...params,
            businesshoursList: params.businesshoursList.map(v => M('BusinessHours', v)),
            distancepricelistList: params.distancepricelistList.map(v => M('DistancePrice', v))
          })
        })
      );
      this.$message({
        message: '保存成功',
        type: 'success'
      });
    }
  }
};
</script>

<style scoped>
h3 {
  padding-bottom: 20px;
  padding-top: 30px;
}
.padding-bt {
  margin-bottom: 20px;
}
.el-select {
  width: 100%;
}
.footer {
  margin: 0 50px;
  display: flex;
  justify-content: flex-end;
  padding: 20px 0;
}
.text {
  color: #999;
}
.wrapper {
  display: flex;
  /* align-items: center;
  justify-content: center; */
}
.imgstyle {
  display: block;
  width: 120px;
  height: 120px;
  color: #888;
  border: 1px dashed #d8d8d8;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 20px;
}
</style>
